import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import styles from "@/styles/Dashboard.module.scss";
import { env } from "@/lib";
import { useDashboardPageAccess } from "@/hooks/useDashboardPageAccess";
import { useNow } from "@/hooks/useNow";
import { useBuildingModules } from "@/hooks/useBuildingModules";
import DashboardHero from "@/components/dashboard/DashboardHero";
import TodayStrip from "@/components/dashboard/TodayStrip";
import ModuleGrid from "@/components/dashboard/ModuleGrid";
import NewsList from "@/components/dashboard/NewsList";
import HelpCard from "@/components/dashboard/HelpCard";
import HelpCentreCard from "@/components/dashboard/HelpCentreCard";

export const Route = createFileRoute("/_portal/dashboard/")({
  component: Dashboard,
});

/** Composition only. Every section decides for itself whether it has anything to show. */
function Dashboard() {
  const { t } = useTranslation();
  const { allowDashboardPageAccess } = useDashboardPageAccess();
  // Ticks, so time-bound cards (lunch pass, waiting visitor) appear and expire on their own.
  const now = useNow();
  // Resolved once here: the sections all read the same list.
  const modules = useBuildingModules();

  if (!allowDashboardPageAccess) return null;
  return (
    <div className={styles.page}>
      <DashboardHero now={now} modules={modules} />
      <TodayStrip now={now} modules={modules} />
      <ModuleGrid modules={modules} />
      <div className={styles.mainRow}>
        <div className={styles.mainCol}>
          <NewsList now={now} modules={modules} />
          <HelpCentreCard />
        </div>
        <aside className={styles.aside}>
          <HelpCard />
        </aside>
      </div>
      <p className={styles.version}>
        {t("PORTAL_VERSION")} {env("VITE_FRONTEND_VERSION")}
      </p>
    </div>
  );
}
